// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.i8l8E{margin-top:8px;width:100%;border-radius:4px}._Yyhd{margin:-16px 0}._Yyhd.lDL5I{margin:0}.XYvyh{padding:8px 0;align-items:center;gap:8px;cursor:pointer}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"searchbox": `i8l8E`,
	"serviceItemsWrapper": `_Yyhd`,
	"noNegativeMargin": `lDL5I`,
	"serviceItem": `XYvyh`
};
export default ___CSS_LOADER_EXPORT___;
